import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './SegmentedControl.scss';

/**
 * One-of-N picker at the toolbar's 28px control height.
 * @param {{ value: any, label: string }[]} options
 */
const SegmentedControl = ({ label, options, value, onChange }) => (
  <div className='silent-eval-segmented' role='group' aria-label={label}>
    {options.map(option => (
      <button
        key={option.value}
        type='button'
        className={cn('segment', { active: value === option.value })}
        aria-pressed={value === option.value}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </button>
    ))}
  </div>
);

SegmentedControl.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.any, label: PropTypes.string.isRequired })).isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
};

export default SegmentedControl;
